import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FormTemplateGeneratorService } from '../../form-template-generator.service';
import { FormFieldConfig, PhoneConfig } from './../../../form-template-model';

@Component({
  selector: 'csi-form-template-email-field-generator',
  templateUrl: './form-template-email-field-generator.component.html',
  styleUrls: ['./form-template-email-field-generator.component.css']
})
export class FormTemplateEmailFieldGeneratorComponent implements OnInit {
  @Input() config: FormFieldConfig & { typeConfig: PhoneConfig };
  @Input() control: FormControl;
  @Input() formTemplateFieldKey: string;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() supportingFields: { [key: string]: FormFieldConfig };

  constructor(public formTemplateGeneratorService: FormTemplateGeneratorService) {}

  ngOnInit() {
    this.control.setValidators(
      [this.config.required ? Validators.required : null, Validators.email].filter(
        validator => !!validator
      )
    );
  }
}
